import { paramsResponsePayloadToModel } from 'core/utils/searchFilters/mappers';
import {
  PremiumUserListResponseModel,
  PremiumUserListResponsePayload,
  PremiumUserModel,
  PremiumUserPayload,
  PremiumUserProjectModel,
  PremiumUserProjectPayload,
} from '../model';

const payloadToPremiumUserProject = ({ project_id, project_name }: PremiumUserProjectPayload): PremiumUserProjectModel => {
  return {
    projectId: project_id ?? '',
    projectName: project_name ?? '',
  };
};

const payloadToPremiumUser = ({
  user_active,
  user_client_id,
  user_confirmed_at,
  user_email,
  user_id,
  user_last_access,
  user_name,
  user_project_list,
  user_roles,
}: PremiumUserPayload): PremiumUserModel => {
  const transformedUserProjectList = user_project_list.map((item) => payloadToPremiumUserProject(item)) ?? [];

  return {
    userActive: user_active ?? false,
    userClientId: user_client_id ?? '',
    userConfirmedAt: user_confirmed_at ?? '',
    userEmail: user_email ?? '',
    id: user_id ?? '',
    userLastAccess: user_last_access ?? null,
    userName: user_name ?? '',
    userProjectList: transformedUserProjectList,
    userRoles: user_roles ?? [],
  };
};

export const payloadToPremiumUserListResponse = ({
  data,
  links,
  meta,
  filters,
}: PremiumUserListResponsePayload): PremiumUserListResponseModel => {
  const transformedUserList = data.user_list.map((item) => payloadToPremiumUser(item)) ?? [];

  return {
    data: {
      userList: transformedUserList,
    },
    ...paramsResponsePayloadToModel({ links, meta, filters }),
  };
};
